
jQuery(document).ready(function($) {

  // FUNCTIONS

    // https://ultimatecourses.com/blog/ditch-the-array-foreach-call-nodelist-hack
      var forEach = function (array, callback, scope) {
        for (var i = 0; i < array.length; i++) {
          callback.call(scope, i, array[i]); // passes back stuff we need
        }
      };

    // open social share dialogs in new window as needed
      var popupCenter = function(url, title, w, h) {
        // Fixes dual-screen position                         Most browsers      Firefox
        var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
        var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        var left = ((width / 2) - (w / 2)) + dualScreenLeft;
        var top = ((height / 3) - (h / 3)) + dualScreenTop;

        var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

        // Puts focus on the newWindow
        if (newWindow && newWindow.focus) {
          newWindow.focus();
        }
      };

    // wait polyfill
      var waitForFinalEvent = (function () {
        var timers = {};
        return function (callback, ms, uniqueId) {
          if (!uniqueId) { uniqueId = "Don't call this twice without a uniqueId"; }
          if (timers[uniqueId]) { clearTimeout (timers[uniqueId]); }
          timers[uniqueId] = setTimeout(callback, ms);
        };
      })();

    // how long to wait before deciding the resize has stopped, in ms. Around 50-100 should work ok.
      var timeToWaitForLast = 100;

    // defines initial aspect ratios for container resize calculations
      function set_background_video_aspect_ratio(){
        $('.hero__video__container').each( function(){
          $(this).data('height', $(this).height() );
          $(this).data('width', $(this).width() );
        });

        $('.hero__video__player').each( function(){
          $(this).data('height', $(this).height() );
          $(this).data('width', $(this).width() );
        });
      }

    // scales background video to cover variable height container  
      function scale_native_background_videos() {

        var videoHeight;
        var videoWidth;

        $('.hero__video__player').each( function() {

          var player_background = $(this).parents('.hero__video__container');
          var player_container = $(this);
          var player_element= player_container.find('.hero__video__element');

          var container_width = player_background.width();
          var container_height = player_background.height();

          var container_ratio = container_height / container_width;
          var videoAspectRatio = player_element.data('video-height') / player_element.data('video-width');

          // console.log(container_ratio + ' vs. ' + videoAspectRatio);

          if ( container_ratio > videoAspectRatio ) {
            videoHeight = container_height;
            videoWidth = videoHeight / videoAspectRatio;
            $(this).css({'margin-top' : 0, 'margin-left' : -(videoWidth - container_width) / 2 + 'px'});

            $(this).width(videoWidth).height(videoHeight);  
          }

          else {
            $(this).width(container_width);
            $(this).css('height', container_width * videoAspectRatio);

            videoHeight = container_height;
            videoWidth = videoHeight / videoAspectRatio;
            $(this).css({'margin-left' : 0, 'margin-top' : (container_height - (container_width * videoAspectRatio) ) / 2 + 'px'});
          }

        });

      }

  // EVENTS

    // mobile navigation
      $('.nav__toggle').click( function() {
        $('body').toggleClass('nav--open');
        // $('.nav__container').scrollTo(0);
      });

      $('.nav__sidebar__background').click( function() {
        $('body').removeClass('nav--open');
      });

    // mobile menu drawer(s)
      $('.nav__primary--mobile .nav__primary__menu__item--has_children > a .icon__container').click( function(e) {
        e.preventDefault();

        var current_sub_menu = $(this).parents('.nav__primary__menu__item').find('.nav__primary__submenu');
        $('.nav__primary--mobile .nav__primary__submenu').not(current_sub_menu).slideUp(200);
        current_sub_menu.slideToggle(200);

        var current_menu_item = current_sub_menu.parents('.nav__primary__menu__item');
        $('.nav__primary__menu__item').not(current_menu_item).removeClass('nav__primary__menu__item--open');
        current_menu_item.toggleClass('nav__primary__menu__item--open');
      });


    // product drawer toggle

      $('.drawers__toggle').click( function(e) {
        e.preventDefault();

        var my_link = $(this);
        my_link.toggleClass('drawers__toggle--open')

        var target_drawer = my_link.nextAll('.drawers__content')
        target_drawer.slideToggle(400);
      });

    // video modals
      $('.video__play a').fancybox({
        protect: true,
        autoSize: false,
        autoScale: false,
        autoDimensions: false,

        slideClass: 'hero__video__fancybox',
        
        width: 1280,
        
        youtube : {
          showinfo : 0
        },

        vimeo : {
          color : 'C69C17'
        },

        touch: false,
        infobar : false,
        toolbar  : false,
        smallBtn : true,
        buttons : [
          // 'slideShow',
          // 'fullScreen',
          // 'thumbs',
          // 'share',
          //'download',
          //'zoom',
          'close'
        ],

        btnTpl: {
          smallBtn:
          '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small">' +
          '<span class="text">Close</span>' + 
          '<svg xmlns="http://www.w3.org/2000/svg" width="50.344" height="26.968" viewBox="0 0 50.344 26.968"><g transform="translate(5501.39 14459.391)"><line id="Line_1887" data-name="Line 1887" x2="49.436" y2="24.571" transform="translate(-5500.936 -14458.07)" fill="none" stroke="currentColor" stroke-width="2"/><line id="Line_1889" data-name="Line 1889" y1="25.186" x2="49.436" transform="translate(-5500.936 -14458.5)" fill="none" stroke="currentColor" stroke-width="2"/></g></svg>' +
          "</button>"
        },

        afterShow: function() {
          $('.hero__video__element').each( function() {
            this.pause();
          });
        },

        beforeClose: function() {
          $('.hero__video__element').each( function() {
            this.play();
          });
        },

      });

    // product quick view modals
    $('.collection__item__quickview').on('click', function(e) {
      e.preventDefault();
      $(this).parents('.boost-pfs-filter-product-item').find('.boost-pfs-quickview-btn').trigger('click');
    });

    // form focus states
      $('.contact__text, .contact__select').on('focus', function() {
        var my_parent = $(this).parents('.contact__form__field');

        my_parent.removeClass('contact__form__field--has_value');
        my_parent.addClass('contact__form__field--focused');
      });

      $('.contact__text, .contact__select').on('blur', function() {
        var my_parent = $(this).parents('.contact__form__field');

        my_parent.removeClass('contact__form__field--focused');

        if ( $(this).val() !== '' ) {
          my_parent.addClass('contact__form__field--has_value');
        }

      });

    // share popup for some platforms
      $('a.popup').click( function(e) {
        e.preventDefault();

        var self = $(this);
        popupCenter(self.attr('href'), self.attr('title'), 580, 470);
        
      });

    // native share support
      $('.product__hero__actions__item--share a').on('click', function(e) {
        
        e.preventDefault();

        var my_text = $('.product__hero__description').text().trim();

        console.log('trying to share', my_text);

        if (navigator.share) {
          
          navigator.share({
            title: document.title,
            text: my_text,
            url: window.location.href,
          })
            .then(() => console.log('Successful share'))
            .catch((error) => console.log('Error sharing', error));
        }
      });

      if (! navigator.share) {
        $('.product__hero__actions').addClass('product__hero__actions--no_sharing');
        
      }

    // click to copy url
      $('.single__share__url a').click( function(e) {

        var my_url = $(this);

        e.preventDefault();

        var temp_value = $("<input>");
        $('body').append(temp_value);
        temp_value.val( my_url.attr('href') ).select();
        
        document.execCommand("copy");

        temp_value.remove();
        my_url.focus();
        
        my_url.find('span').text('Copied');

        // $('.single__share__url__success').addClass('single__share__url__success--visible');
        setTimeout( function() {
          // $('.single__share__url__success').removeClass('single__share__url__success--visible');
          my_url.find('span').text('Copy link');
        }, 1000 );

      });

    // faq question drawers

      $('.faqs__heading a').click( function(e) {
        var my_parent = $(this).parents('.faqs__item');
        e.preventDefault();

        my_parent.toggleClass('faqs__item--open');
        my_parent.find('.faqs__copy').slideToggle(200);
      });

    // blog category change
      $('select[data-blog-tag-filter]').on('change', function(e) {
        // console.log('change detected');
        location.href = $(this).val();
      });

    // trigger option update for product variants
      $('.single-option-selector').on('change', function() {

        var my_select = $(this);
        var my_selected_option_eq = my_select.find('option:selected').index();

        $('.product-form__variants option').removeAttr('selected');
        $('.product-form__variants option').eq(my_selected_option_eq).attr('selected', 'selected');
      });

    // increment quantity buttons
      $('.product__quantity__button').on('click', function(){
        var qty = parseInt($(this).parent('.product__quantity__container').find('.product-form__input').val());
        if($(this).hasClass('product__quantity__button--plus')) {
          qty++;
        }else {
          if(qty > 1) {
            qty--;
          }
        }
        qty = (isNaN(qty))?1:qty;
        $(this).parent('.product__quantity__container').find('.product-form__input').val(qty);
      }); 

    // hashtag navigation takeover
      $('a[href*="#"]').on('click', function(e) {

        var my_href = $(this).attr('href'); //Puts hash in variable, and removes the # character
        var my_anchor = my_href.split('#')[1];

        var my_destination = $('.anchor[data-anchor="' + my_anchor + '"]');
        if ( my_destination.length > 0 ) {

          e.preventDefault();

          var my_offset = $('.site__header').height() * -1;
            
          $.scrollTo( my_destination, 500, {
              offset: my_offset
            }
          );

        }

    });

    // product template: scroll down to FAQ
      $('.product__hero__actions__item--faq a').on('click', function(e) {
        
        var my_destination = $('.drawers--faq');
        if ( my_destination.length > 0 ) {

          e.preventDefault();

          var my_offset = $('.site__header').height() * -1;
            
          $.scrollTo( my_destination, 500, {
              offset: my_offset
            }
          );

        }

      });


    // play audio
      $('.product__audio__icon').on('click', function() {
        
        var my_index = $(this).parents('.product__audio__item').index();
        forEach( wavesufter_array, function(item, value) {
          if ( item !== my_index ) {
            $('.product__audio__item').eq(item).removeClass('product__audio__item--playing');
            wavesufter_array[item].stop(); 
          }
        });

        $(this).parents('.product__audio__item').toggleClass('product__audio__item--playing');
        wavesufter_array[my_index].playPause();

        
      });

    // audio CTA to submit to cart if no variant dropdown detected, otherwise scrolls ot top
      $('.product__audio__cta a.button--main_product').on('click', function(e) {
        e.preventDefault();

        if ( $('.product__form select option').length > 1 ) {
          var my_destination = $('.product__hero');
          if ( my_destination.length > 0 ) {

            var my_offset = $('.site__header').height() * -1;
            
            $.scrollTo( my_destination, 500, {
                offset: my_offset
              }
            );

          }
        }
        else {

          $('.product-form__cart-submit').trigger('click');

        }
      });
    
  // INIT

    // sticky header
      if ( $('.site__header--default').length > 0 ) {
        
        var nav_sticky = new Waypoint.Sticky({
          element: $('.site__header--default')[0]
        });
  
        var my_header_offset = function() {
          return $('.site__header--default').height() * -1;
        };
  
        var nav_header_down = new Waypoint({
          element: $('.site__header--default')[0],
          handler: function(direction) {
  
            if ( direction === 'down') {
              $('.site__header--fixed').addClass('site__header--fixed_visible');
              $('.site__header__toggle').addClass('site__header__toggle--fixed_visible');
              $('.nav__sidebar').addClass('nav__sidebar--fixed_visible');
            }
            
            if ( direction === 'up') {
              $('.site__header--fixed').removeClass('site__header--fixed_visible');
              $('.site__header__toggle').removeClass('site__header__toggle--fixed_visible');
              $('.nav__sidebar').removeClass('nav__sidebar--fixed_visible');
            }
  
          },
          offset: my_header_offset,
        });
        
      }
      

    // barcode stretch
      $('.barcode').each( function() {

        var my_container = $(this);
        var my_image = my_container.find('svg');

        var my_barcode_timeline = gsap.timeline({
          scrollTrigger: {
            trigger: my_container,
            start: 'top bottom',
            end: 'top center',
            scrub: true,
            // markers: true,
            // once: true,
          }
        });

        my_barcode_timeline.to(my_image, {
          transform: 'scaleY(1050%)',
          duration: 1,
        });

      });

    // barcode stretch
      $('.lp2_video__embed').each( function() {

        function playVideo(vid) {
          vid.play();
        }
        
        function pauseVideo(vid) {
          vid.pause();
        }

        var my_container = $(this);
        var my_video = my_container.find('video')[0];

        var my_video_timeline = gsap.timeline({
          scrollTrigger: {
            trigger: my_container,
            start: 'bottom bottom',
            end: 'bottom top',
            // scrub: true,
            // markers: true,
            // once: true,
            onToggle: self => self.isActive ? playVideo(my_video) : pauseVideo(my_video),
            toggleActions: 'play pause reverse none'
          }
        });

      });

    // custom waveform visualizer

      var wavesufter_array = [];

      $('.product__audio__visualizer').each( function() {

        var my_visualizer = this;
        var my_index = $(this).parents('.product__audio__item').index();

        var my_audio = $(my_visualizer).data('audio-src');
        var my_peaks = fetch( $(my_visualizer).data('peak-src') );

        wavesufter_array[my_index] = WaveSurfer.create({
          container: my_visualizer,
          height: 60,
          barGap: 2,
          
          hideScrollbar: true,
          interact: false,
          // normalize: true,
          // fillParent: false,
          // scrollParent: true,
          responsive: true,
          splitChannels: true,
          splitChannelsOptions: {
            overlay: true,
            channelColors: {
              0: {
                progressColor: '#7FAD1F',
                waveColor: '#bfc0a6'
              },
              1: {
                progressColor: '#7FAD1F',
                waveColor: '#bfc0a6'
              }
            }
          },
          backend: 'MediaElement'
        });

        wavesufter_array[my_index].load(my_audio, my_peaks.data, 'none');
      
      } );

    // social sharing sticky column
      if ( $('.single__share--column').length > 0 ) {

        var my_share_offset = function() {
          var header_height = $('.site__header--fixed').height() * -1;
          var article_padding = 90;
          
          var my_offset = header_height + article_padding;
          return my_offset;
        };

        var share_down = new Waypoint({
          element: $('.single_content__copy')[0],
          handler: function(direction) {

            if ( direction === 'down') {
              $('.single__share__column__container').addClass('single__share__column__container--fixed');
            }
            
            if ( direction === 'up') {
              $('.single__share__column__container').removeClass('single__share__column__container--fixed');
            }

          },
          offset: my_share_offset,
        });


        var my_share_end_offset = function() {
          var share_end_height = $('.single__share--horizontal').height() * -10;
          return share_end_height;
        };

        var share_end = new Waypoint({
          element: $('.single__share--horizontal')[0],
          handler: function(direction) {

            if ( direction === 'down') {
              $('.single__share__column__container').addClass('single__share__column__container--fixed_end');
            }
            
            if ( direction === 'up') {
              $('.single__share__column__container').removeClass('single__share__column__container--fixed_end');
            }

          },
          offset: 'bottom-in-view',
        });

      }

    // show 2 random related posts
      $('.recent--related_hidden').each( function() {

        var item_count = 2;

        var my_list = $(this);
        
        var my_items = my_list.find('.recent__list__item--related_hidden');
        if ( my_items.length < 1 ) {
          return false;
        }

        for (var i = 0; i < item_count; i++) {
          my_items = my_list.find('.recent__list__item--related_hidden');

          var random = Math.floor(Math.random() * my_items.length);
          my_list.find('.recent__list__item').eq(random).removeClass('recent__list__item--related_hidden');
        }

        
        my_list.removeClass('recent--related_hidden');

      });

    // check for autocomplete text on form elements
      $('.contact__text, .contact__textarea, .contact__select').each( function() {
        var my_parent = $(this).parents('.contact__form__field');

        if ( $(this).val() !== '' ) {
          my_parent.addClass('contact__form__field--has_value');  
        }
        
      });

    // wrap video embed in fluid width container
      $('.single_content__copy iframe').each( function() {

        var my_embed = $(this);
        if ( typeof my_embed.attr('width') === 'undefined' || typeof my_embed.attr('height') === 'undefined' ) {
          return false;
        }

        var my_width = my_embed.attr('width');
        var my_height = my_embed.attr('height');

        var my_aspect_ratio = ( my_height / my_width * 100 ) + '%';

        my_embed.wrap('<div class="video__embed__outer"><div class="video__embed" style="padding-bottom:' + my_aspect_ratio + ';">');

      });

    // testimonial gallery block
      $('.testimonials__carousel').each( function() {

        var my_carousel = $(this);

        var my_navigation = my_carousel.parents('.testimonials').find('.testimonials__nav');

        var carousel_block = new Swiper(my_carousel[0], {
          speed: 500,
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          loop: false,
          pagination: false,
          navigation: false,

          allowTouchMove: false,

          spaceBetween: 0,
          slidesPerView: 1,

          on: {
            init: function () {
              my_navigation.find('.testimonials__nav__item').first().addClass('testimonials__nav__item--current');
            },
          },

        });

        $('.testimonials__nav__item').on('click', function(e) {
          e.preventDefault();

          var my_carousel = this;
          carousel_block.slideTo( $(my_carousel).index(), 500 );

          my_navigation.find('.testimonials__nav__item').removeClass('testimonials__nav__item--current');
          my_navigation.find('.testimonials__nav__item').eq(carousel_block.realIndex).addClass('testimonials__nav__item--current');

          
        });

      });

    // gallery block
      $('.photo_gallery__carousel').each( function() {

        var my_carousel = $(this);
        var carousel_block = new Swiper(my_carousel[0], {
          speed: 500,
          effect: 'slide',
          loop: true,
          pagination: {
            el: my_carousel.find('.swiper-pagination')[0],
            type: 'bullets',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },


          centeredSlides: true,
          spaceBetween: 20,
          CSSWidthAndHeight: true,
          slidesPerView: 'auto',

          on: {
            init: function () {
              
            },

          },

        });

      });

    // collections plugins carousel

      $('.collection__plugins__carousel').each( function() {

        var my_carousel = $(this);
        var carousel_block = new Swiper(my_carousel[0], {
          speed: 500,
          effect: 'slide',
          loop: false,
          pagination: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },

          spaceBetween: 20,
          CSSWidthAndHeight: true,
          slidesPerView: 'auto',

          on: {
            init: function () {
              
            },

          },

        });

      });

    // product expansions carousel
    
      $('.product__expansions__carousel').each( function() {

        var my_carousel = $(this);
        var carousel_block = new Swiper(my_carousel[0], {
          speed: 500,
          effect: 'slide',
          loop: false,
          pagination: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },

          spaceBetween: 20,
          CSSWidthAndHeight: true,
          slidesPerView: 'auto',

          on: {
            init: function () {
              
            },

          },

        });

      });

    // product hero carousel
      $('.product__hero__carousel').each( function() {

        var my_carousel = $(this);
        var carousel_block = new Swiper(my_carousel[0], {
          speed: 500,
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          loop: true,
          pagination: {
            el: my_carousel.find('.swiper-pagination')[0],
            type: 'bullets',
            clickable: true,
          },
          navigation: false,
          spaceBetween: 0,
          slidesPerView: 1,

          CSSWidthAndHeight: true,

          on: {
            init: function () {
              
            },

          },

        });

      });

    // hash navigation check
      if( window.location.hash ) {
                
        var my_anchor = window.location.hash.substring(1); //Puts hash in variable, and removes the # character

        var my_destination = $('.anchor[data-anchor="' + my_anchor + '"]');
        if ( my_destination.length > 0 ) {

          setTimeout( function() {
          
            var my_offset = $('.site__header').height() * -1;
            
            $.scrollTo( my_destination, 500, {
                offset: my_offset
              }
            );

          }, 200 );

        }

      }

    set_background_video_aspect_ratio();
    scale_native_background_videos();

  // matchHeight rules

    $('.lp2_testimonials__item blockquote').matchHeight();


  // RESIZED

  $(window).on('resize', function() {

    waitForFinalEvent( function() {
      Waypoint.refreshAll();

      current_canvas_width  = $('.hero__video__player').width();
      current_canvas_height = $('.hero__video__player').height();

      scale_native_background_videos();

      // recenter_map();
    },
    timeToWaitForLast, 'main_resize_event');

  });

});

